































import { Component, Prop, Inject, Mixins } from "vue-property-decorator";
import { IContractProduct } from "@/models/contracts";
import { IContractProductProvider } from "@/models/providers/contractProduct";
import { DelegateObjectTypes } from "@/data/enums/delegates";
import Context from "@/mixins/context";

@Component({
  components: {
    "delegates-provider": () =>
      import("@/components/app/global/delegates/delegatesProvider.vue"),
    "delegates-table": () =>
      import("@/components/app/global/delegates/delegatesTable.vue")
  }
})
export default class ContractProductDelegates extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => IContractProductProvider;

  // Props

  @Prop({ required: true })
  public productId!: IContractProduct["id"];

  // Life-cycle methods

  public mounted() {
    // Redirect delegates
    if (this.isAdmin) return;
    if (this.cProdData.isDelegatedAccess) {
      // $nextTick prevents ValidationObserver console error
      this.$nextTick(() => {
        this.$route.matched.splice(-1);
        const parent = this.$_.last(this.$route.matched);
        this.$router.replace({ name: parent?.name }).catch(err => err);
      });
    }
  }

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get delegatesProviderProps() {
    return {
      objectType: DelegateObjectTypes.CONTRACT_PRODUCT,
      objectId: this.productId
    };
  }
}
